import React, { InputHTMLAttributes } from 'react';

import './ToggleSwitch.css';

type Props = {
  className?: string;
  id?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
};

const generateInputAttributes = (props: Props) => {
  const { id, name, checked, onChange, disabled } = props;

  const attrs: Partial<InputHTMLAttributes<HTMLInputElement>> = {
    type: 'checkbox',
    onChange,
    disabled,
    checked,
  };

  if (id) {
    attrs.id = id;
  }
  if (name) {
    attrs.name = name;
  }

  return attrs;
};

function ToggleSwitch(props: Props) {
  const { className, disabled } = props;
  const disabledClass = disabled ? 'disabled' : '';
  const additionalClass = className || '';

  const finalClass = `ToggleSwitch ${additionalClass}`.trim();
  const sliderClass = `ToggleSwitch-slider round ${disabledClass}`.trim();

  const inputAttribs = generateInputAttributes(props);

  return (
    <label className={finalClass}>
      <input {...inputAttribs} />
      <span className={sliderClass} />
    </label>
  );
}

ToggleSwitch.defaultProps = {
  className: '',
  disabled: false,
};

export default ToggleSwitch;
